import React from 'react';
import { ScreenRedirect } from '@atlassian/jira-screen-redirect/src/ui/ScreenRedirect.tsx';

export const redirectTo = (redirectUrl: string) => (): React.JSX.Element => (
	<ScreenRedirect to={redirectUrl} />
);
